import type { CreditCardWithCurrencies } from '@contracts/payment/CreditCard';
import { PaymentClient } from '@src/orders/services/PaymentClient';
import { useQuery } from '@tanstack/react-query';

interface Props {
  clientId: string;
}

export const useListAllCreditCards = ({ clientId }: Props) => {
  const { data: availableCreditCards = [], refetch } = useQuery<
    CreditCardWithCurrencies[]
  >({
    queryKey: ['getAllCreditCards', clientId],
    queryFn: () => PaymentClient.getAllCreditCards({ clientId }),
  });

  return {
    availableCreditCards,
    refetch,
  };
};
